import { render, staticRenderFns } from "./EditOfficialAccountDialog.vue?vue&type=template&id=a0dcfaaa&scoped=true&"
import script from "./EditOfficialAccountDialog.vue?vue&type=script&lang=js&"
export * from "./EditOfficialAccountDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditOfficialAccountDialog.vue?vue&type=style&index=0&id=a0dcfaaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dcfaaa",
  null
  
)

export default component.exports